var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-2",attrs:{"fluid":"","fill-height":""}},[_c('v-row',{staticClass:"stepper"},[_c('v-col',[_c('Stepper',{attrs:{"type":_vm.type}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }